import React, { useEffect, useState } from 'react';
import { Form, Col, Button, ListGroup, Row, Card } from 'react-bootstrap';
import VerticalTabs from '../tabs/VerticalTabs';
import Loader from '../loader/Loader';
import utils from '../../helpers/utils';
import { FaImage } from 'react-icons/fa';
import TooltipImage from '../tooltip/TooltipImage';
import { Actions } from '../../../client/Actions';
import CustomCard from '../CustomCard';
import SecureIframe from './SecureIframe';
import { toast } from 'react-toastify';
import FadeCardImage from '../image/FadeCardImage';

const FormInputFile = ({
                         titleText,
                         labelText,
                         formats = ['PNG', 'JPG'],
                         idName,
                         path,
                         single,
                         requestParameterName,
                         setImagesParentStore,
                         fileNameField,
                         filePathField,
                         imagesParentStore,
                         inputSize,
                         btnSize,
                         list = false,
                         disabled,
                         privateView,
                         onUploaded,
                         onDeleteFile,
                         uploadOnTop = false,
                         imageColumns
                       }) => {
  const default_label_txt = 'Wybierz plik';

  const [store, setStore] = useState(null);
  const [labelTxt, setLabelTxt] = useState(labelText || default_label_txt);
  const [isBtnDisabled, setIsBtnDisabled] = useState(true);
  const [loader, setLoader] = useState(false);

  const validateAndUpload = (event) => {
    setLoader(true);
    const newformData = new FormData();
    newformData.append(requestParameterName, store);
    newformData.append('description', null);
    Actions.post(path, newformData, callback);
  };

  const onImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const maxSizeMB = 10;
      const fileSizeMB = file.size / (1024 * 1024);

      if (fileSizeMB > maxSizeMB) {
        toast.warn(`Plik jest za duży (${fileSizeMB.toFixed(2)} MB). Maksymalny rozmiar to ${maxSizeMB} MB.`);
        event.target.value = null;
        return;
      }

      // Validate file format
      const fileExtension = file.name.split('.').pop()?.toUpperCase();
      if (formats && formats.length > 0 && !formats.includes(fileExtension)) {
        toast.warn(`Nieobsługiwany format pliku. Dozwolone formaty: ${formats.join(', ')}`);
        event.target.value = null;
        return;
      }

      setStore(file);
      setLabelTxt(file.name);
      setIsBtnDisabled(false);
    } else {
      setLabelTxt(default_label_txt);
      setStore(null);
      setIsBtnDisabled(true);
    }
  };

  useEffect(() => {
    if (store) {
      validateAndUpload();
    }
  }, [store]);

  const onImageInputClick = (event) => {
    event.target.value = null;
    setStore(null);
    setIsBtnDisabled(true);
  };

  const callback = (data) => {
    if (onUploaded) {
      onUploaded(data);
      setStore(null);
      setLabelTxt(default_label_txt);
      setIsBtnDisabled(true);
      setLoader(false);
      return;
    }

    imagesParentStore.push({
      id: data.id,
      [fileNameField]: data[fileNameField],
      [filePathField]: data[filePathField],
      description: data.description
    });
    setImagesParentStore([...imagesParentStore]);

    setStore(null);
    setLabelTxt(default_label_txt);
    setIsBtnDisabled(true);
    setLoader(false);
  };

  const handleDeleteFile = (id) => {
    if (onDeleteFile) {
      onDeleteFile(id);
      return;
    }

    const items = imagesParentStore.filter(img => img.id !== id);
    setImagesParentStore(items);
  };

  if (privateView) {
    const singleFile = imagesParentStore.length === 1 ? imagesParentStore[0] : null;

    return (
      <>
        <Form.Label><strong>{titleText}</strong></Form.Label>

        {singleFile ? (
          <CustomCard shadow={false} title={singleFile[fileNameField]}>
            <SecureIframe
              filePath={singleFile[filePathField]}
              fileName={singleFile[fileNameField]}
            />
          </CustomCard>
        ) : (
          <VerticalTabs
            config={{
              defaultActiveKey: imagesParentStore[0]?.id,
              tabs: imagesParentStore.map((file) => ({
                key: file.id,
                label: file[fileNameField],
                withHeader: false,
                content: (
                  <CustomCard shadow={false} title={file[fileNameField]}>
                    <SecureIframe
                      filePath={file[filePathField]}
                      fileName={file[fileNameField]}
                    />

                  </CustomCard>
                )
              }))
            }}
          />
        )}
      </>
    );
  }

  const uploadInput = !disabled && (single ? imagesParentStore?.length === 0 : true) ? (
    <Row className="mt-3">
      <Col md={12}>
        <div
          className={`border border-dashed p-4 rounded text-center position-relative ${
            isBtnDisabled ? 'bg-light' : 'bg-white'
          }`}
          style={{
            borderColor: '#ccc',
            cursor: disabled ? 'not-allowed' : 'pointer'
          }}
          onClick={() => {
            if (!disabled) document.getElementById(idName)?.click();
          }}
          onDragOver={(e) => e.preventDefault()}
          onDrop={(e) => {
            e.preventDefault();
            if (!disabled) {
              const files = e.dataTransfer.files;
              if (files.length) {
                const fakeEvent = { target: { files } };
                onImageChange(fakeEvent);
              }
            }
          }}
        >
          <FaImage size={32} className="mb-2 text-muted" />
          <p>
            <strong className="text-primary">Wybierz plik</strong> lub
            przeciągnij i upuść
          </p>
          <small className="text-muted">{formats.join(', ')} do 10MB</small>
        </div>

        <Form.Control
          type="file"
          id={idName}
          style={{ display: 'none' }}
          onChange={onImageChange}
          onClick={onImageInputClick}
          disabled={disabled}
        />
      </Col>
    </Row>
  ) : (
    ''
  );

  return (
    <>
      <Loader loader={loader} setLoader={setLoader} />
      <Form.Label><strong>{titleText}</strong></Form.Label>
      {uploadOnTop && uploadInput}
      {formats.includes('PDF') || list ? (
        <ListGroup variant="flush" className="mt-3">
          {imagesParentStore.map((el) => (
            <ListGroup.Item key={el.id}>
              <Row>
                <Col md={disabled ? 12 : 10}>
                  <TooltipImage
                    className="file_name_text_input_form"
                    fileName={el[fileNameField]}
                    filePath={el[filePathField]}
                    privateView={privateView}
                  >
                    {el[fileNameField]}
                  </TooltipImage>
                </Col>
                {!disabled && (
                  <Col md={2}>
                    <i
                      className="fas fa-trash-alt delete_btn_image cursor-pointer"
                      onClick={() => handleDeleteFile(el.id)}
                    />
                  </Col>
                )}
              </Row>
            </ListGroup.Item>
          ))}
          {imagesParentStore.length === 0 && disabled && (
            <div className="text-muted mt-2 ms-2">Brak załączników</div>
          )}
        </ListGroup>
      ) : (
        <Row className="mt-3">
          {imagesParentStore.map((el) => (
            <Col
              key={el.id}
              xs={imageColumns?.xs ?? 6}
              sm={imageColumns?.sm ?? 4}
              md={imageColumns?.md ?? 4}
              lg={imageColumns?.lg === 5 ? undefined : imageColumns?.lg ?? 4}
              className={`mb-4 ${imageColumns?.lg === 5 ? 'file-image-col-lg-5' : ''}`}
            >
              <Card className="h-100 shadow-sm">
                <div className="position-relative">
                  <FadeCardImage
                    src={utils.defaultUrl() + el[filePathField]}
                    alt={el[fileNameField]}
                  />
                  {!disabled && (
                    <Button
                      variant="secondary"
                      size="sm"
                      className="position-absolute top-0 end-0 m-1 rounded-circle p-1"
                      onClick={() => handleDeleteFile(el.id)}
                      style={{ width: 30, height: 30, fontSize: '1rem' }}
                    >
                      &times;
                    </Button>
                  )}
                </div>
                <Card.Body className="p-2">
                  <Card.Text
                    className="small text-truncate text-center"
                    title={el[fileNameField]}
                  >
                    {el[fileNameField]}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      )}

      {!uploadOnTop && uploadInput}
    </>
  );
};

export default FormInputFile;
